import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class UnpaidTaxType extends Enum {
  static FEDERAL = {
    key: 'federal',
    get value() {
      return Lang.t('liability.federal-income-tax');
    }
  };

  static STATE_PROVINCIAL = {
    key: 'state_provincial',
    get value() {
      return Lang.t('liability.provincial-income-tax');
    }
  };

  static MUNICIPAL_PROPERTY = {
    key: 'municipal_property',
    get value() {
      return Lang.t('liability.municipal-property-tax');
    }
  };

  static MUNICIPAL_SCHOOL = {
    key: 'municipal_school',
    get value() {
      return Lang.t('liability.municipal-school-tax');
    }
  };

  static MUNICIPAL_MUTATION = {
    key: 'municipal_mutation',
    get value() {
      return Lang.t('liability.municipal-mutation-tax');
    }
  };
}
